export default "__VITE_ASSET__5s3UM2Na__"